export enum ParamField {
  mbusAddress = "mbus address",
  name = "name",
  type = "type",
  valueOnCleanBoot = "value on clean boot",
  min = "min",
  max = "max",
  default = "default",
  readOnly = "read-only",
  readAccess = "read access",
  flashAddress = "flash address",
  inCodeName = "in code name",
  writeAccess = "write access",
  userInfo = "user_info",
  group = "group",
  subGroup = "sub_group",
  inputType = "input_type",
  inputInfo = "input_info",
  unitType = "unit_type",
  unit = "unit",
  minRef = "min_ref",
  maxRef = "max_ref",
}
